<template>
    <div class="retail_order">
      <!--零售下单头部-->
      <div class="retail_order_top">
        <div class="first_line">
          <div>
            <el-select
              v-model="selectChannelValue"
              multiple
              collapse-tags
              placeholder="渠道">
              <el-option v-for="item in channelList"
                         :key="item.id"
                         :label="item.text"
                         :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div>
            <el-select v-model="selectBrandType" placeholder="品牌">
              <el-option
                v-for="item in brandTypeList"
                :key="item.id"
                :label="item.text"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="w_percent10">
            <el-select v-model="selectClassificationType" placeholder="分类">
              <el-option
                v-for="item in codeClassificationList"
                :key="item.id"
                :label="item.text"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="w_percent10">
            <input type="text" title="尺码" placeholder="尺码" v-model.trim="sizeVal">
          </div>
          <div class="w_percent10">
            <el-select v-model="selectGender" placeholder="性别">
              <el-option
                v-for="item in genderList"
                :key="item.id"
                :label="item.text"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="w_percent10">
            <el-select v-model="selectPriceRange" placeholder="价格范围">
              <el-option
                v-for="item in priceRangeList"
                :key="item.id"
                :label="item.text"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="w_percent10">
            <el-select v-model="selectDiscountRange" placeholder="折扣范围">
              <el-option
                v-for="item in discountRangeList"
                :key="item.id"
                :label="item.text"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="w_percent10">
            <el-select v-model="selectYear" placeholder="年份">
              <el-option
                v-for="item in yearList"
                :key="item.id"
                :label="item.text"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="w_percent10">
            <el-select v-model="selectQuarter" placeholder="季度">
              <el-option
                v-for="item in quarterList"
                :key="item.id"
                :label="item.text"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="second_line">
          <div class="w_percent15"><input type="text" title="货号/品名" v-model="goodsNumName" placeholder="货号/品名"></div>
          <button class="btn btn_normal mr10" @click="queryData()">查询</button>
          <button class="btn btn_normal" @click="exportInventory()">导出库存</button>
        </div>
      </div>

      <!--零售下单内容列表-->
      <div class="retail_order_msg">
        <div class="retail_order_msg_content mb20" v-for="(item, index) in list" :key="index">
          <div class="h80">
            <div class="inb fl">
             <!-- <el-popover
                width="300" height="300"
                trigger="hover">
                <img :src="item.MainImgUrl" width="300" height="300" />
                <img :src="item.MainImgUrl" width="100" height="70"/>
              </el-popover> -->
              <div v-if="item.MainImgUrl">
                <el-dropdown>
                  <img :src="item.MainImgUrl" width="100" height="70"/>
                  <el-dropdown-menu slot="dropdown">
                    <img :src="item.MainImgUrl" width="300" height="300"/>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <img v-if="!item.MainImgUrl" src="../../../assets/img/logo.jpg" width="100" height="70"/>
              <!--<img v-if="!item.MainImgUrl" src="../../../assets/img/inshop-01.png" width="100" height="70"/>-->
            </div>
            <div class="inb ml10">
              <div class="mb7">
                <span class="fwb fs14">货号：</span><label class="fs14 fwb">{{item.GoodsId}}</label>
                <span class="fwb fs14">品名：</span><label class="fs14 fwb">{{item.GoodsName}}</label>
              </div>
              <div class="mb7">
                <span>价格：</span><label class="fcDel">{{item.MarketPrice}}</label>元
                <span>品牌：</span><label class="fcDel">{{item.BrandName}}</label>
              </div>
              <div>
                <span>商品分类：</span><label class="fcDel">{{item.ClassName}}</label>
                <span>性别：</span><label class="fcDel">{{item.GenderName}}</label>
                <span>颜色：</span><label class="fcDel">{{item.GoodsColorName}}</label>
                <span>重量：</span><label class="fcDel">{{item.GoodsWeight}}</label>
                <span>发布季：</span><label class="fcDel">{{item.MarketSeasoin}}</label>
              </div>
            </div>
          </div>
          <div>
            <table class="table">
              <thead>
              <tr>
                <th>
                  仓库
                </th>
                <th v-for="(sizeItem) in item.BaseSizeList">
                  <p>{{sizeItem.Size}}</p>
                  <!--<p>[{{sizeItem.AmericanSize}}]</p>-->
                  <!--<p>[{{sizeItem.EuropeSize}}]</p>-->
                </th>
                <th>合计</th>
                <th>代理价(元)</th>
                <th>折扣</th>
                <th>交单</th>
                <th>发货时间</th>
                <th>配货率(%)</th>
                <!--<th>退货比例+超出扣款</th>-->
                <th>免费退货率（%）</th>
                <th>超比例退货费用</th>
                <th>更新时间</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(channelItem, channelIndex) in item.channel">
                <td>
                  {{channelItem.StoreroomName}}
                </td>
                <td v-for="(sizeMsgItem, sizeIndex) in channelItem.sizeMsgList"
                    @mousemove="batchBtn = (item.GoodsId + '_' + channelItem.StoreroomId)" @mouseleave="batchBtn = null">
                  <a v-if="!sizeMsgItem.stock">{{sizeMsgItem.stock}}</a>
                  <a v-if="sizeMsgItem.stock" @click="addToShoppingCart(item.GoodsId, index, channelIndex, sizeIndex)">{{sizeMsgItem.stock}}</a>
                  <div v-if="batchTxt === (item.GoodsId + '_' + channelItem.StoreroomId) && sizeMsgItem.stock"
                       class="w50 mauto batch_hover">
                    <input type="number" title="下单数量" min="0" step="1" v-model.trim="sizeMsgItem.orderNum">
                  </div>
                </td>
                <td class="pr fcDel batch_hover batch_import"
                    @mousemove="batchBtn = (item.GoodsId + '_' + channelItem.StoreroomId)"
                    @mouseleave="batchBtn = null">
                  {{channelItem.stockTotal}}
                  <a v-if="batchBtn === (item.GoodsId + '_' + channelItem.StoreroomId)"
                     @click="batchAddCarData(item.GoodsId, channelItem.StoreroomId, item, channelIndex)" class="pa no_newline">批量下单</a>
                  <a v-if="batchBtnSubmit === (item.GoodsId + '_' + channelItem.StoreroomId)"
                     @click="batchAddCar()" class="pa no_newline" style="z-index: 100">批量下单</a>
                </td>
                <td>{{channelItem.CostPrice}}</td>
                <td>{{channelItem.CostDiscount}}</td>
                <td>{{channelItem.StopJiaoDanView}}</td>
                <td>{{channelItem.ShipDay | timeday}}</td>
                <td>{{channelItem.RealSendRate}}</td>
                <td>{{channelItem.FreeRefundRate}}</td>
                <td>{{channelItem.OverFreeRefundRateFee}}</td>
                <td>{{channelItem.StockUpdateTime | time}}</td>
              </tr>
              <tr>
                <td>合计</td>
                <td v-for="(sizeStockItem) in item.sizeStockList">{{sizeStockItem.stock}}</td>
                <td>{{item.sizeStockTotal}}</td>
                <td colspan="8"></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!--分页-->
        <div v-if="list.length" class="text_right mt20">
          <el-pagination
            background
            :prev-text="'上一页'"
            :next-text="'下一页'"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="pageSize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>

      <!--弹出框-->
      <retail-order-embed-msg v-if="isShow"
                              :title="dialogTitle"
                              :showType="dialogShowType"
                              :orderMsg="orderParams"
                              @cancelbtn="getSelectDialogEmbed"></retail-order-embed-msg>

      <!--加载框-->
      <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>

      <!--信息提示框-->
      <msg-dialog v-if="isMsg"
                  :txt="txtMsg"
                  :is-suc="isSuc"
                  @closebtn="closeMsgDialog"></msg-dialog>

      <tip v-if="isTip" @closetipbtn="closeTipDialog"></tip>
      <!--蒙版-->
      <div v-if="batchMask" @click="batchAddCar()" class="retail_order_mask"></div>
    </div>
</template>

<script>
  import RetailOrderEmbedMsg from './retail-order-embed-msg';
  import LoadingDialog from '../../public-component/loading-dialog';
  import MsgDialog from '../../public-component/msg-dialog';
  import Tip from '../../public-component/tip';

  export default {
    name: 'retail-order',
    components: {RetailOrderEmbedMsg, LoadingDialog, MsgDialog, Tip},
    computed: {
      goodsList: {
        // getter
        get: function () {
          return this.$store.state.carGoodsList;
        },
        // setter

        set: function (newVal) {
          this.$store.state.carGoodsList = newVal;
          return this.$store.state.carGoodsList;
        }
      }
    },
    data() {
      return {
        list: [], // 列表
        orderParams: null, // 售后列表参数
        channelList: [], // 渠道下拉列表
        selectChannelValue: [], // 选择的渠道列表
        brandTypeList: [], // 查询品牌下拉列表
        selectBrandType: '', // 选择到的查询品牌类型
        codeClassificationList: [], // 查询分类下拉列表
        selectClassificationType: '', // 选择到的查询分类类型
        sizeVal: '', // 尺码
        selectSize: '', // 选择到的尺码
        colorList: [
          {id: 0, text: '颜色'},
          {id: 1, text: '红'},
          {id: 2, text: '绿'},
          {id: 3, text: '蓝'},
          {id: 4, text: '灰'},
          {id: 5, text: '黑'},
          {id: 6, text: '白'}
        ], // 颜色列表
        selectColor: 0, // 选择的颜色
        genderList: [
          {id: 0, text: '性别'},
          {id: 1, text: '男'},
          {id: 2, text: '女'},
          {id: 3, text: '中性'},
          {id: 4, text: '童'}
        ], // 性别列表
        selectGender: 0, // 选择的性别
        priceRangeList: [], // 价格范围下拉列表
        selectPriceRange: '', // 选择的价格范围
        discountRangeList: [], // 价格范围下拉列表
        selectDiscountRange: '', // 选择的加个范围
        yearList: [], // 年份下拉列表
        selectYear: 0, // 选择的年份
        quarterList: [
          {id: '', text: '季度'},
          {id: 'Q1', text: 'Q1'},
          {id: 'Q2', text: 'Q2'},
          {id: 'Q3', text: 'Q3'},
          {id: 'Q4', text: 'Q4'}
        ], // 季度下拉列表
        selectQuarter: '', // 选择的季度
        sortList: [
          {id: '', text: '排序'},
          {id: 1, text: '库存'},
          {id: 2, text: '销量'}
        ], // 排序下拉列表
        selectSort: '', // 选择的排序类型
        goodsNumName: '', // 货号/品名
        goodsMsg: null, //  批量下单货品信息
        channelI: null, // 批量下单货品信息的渠道下标
        batchBtn: null, // 批量下载按钮
        batchBtnSubmit: null, // 批量下载提交按钮
        batchTxt: null, // 批量下载文本框显示
        batchMask: false, // 批量下载蒙版
        isLoading: false, // 是否显示加载框
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '信息框内容', // 信息框内容
        isTip: false, // 提示框显示
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 0 // 总条数
      }
    },
    methods: {
     /* ...mapMutations(
        ['deleteCarGoods', 'updateCarGoods']
      ), */
     // 查询数据
     queryData() {
       this.currentPage = 1;
       this.getRetailGoodsPageData();
     },

      // 查询零售下单货品库存信息分页数据 （按照货号个数分页）
      getRetailGoodsPageData() {
        this.isLoading = true;
        const params = {
          storeroomId: this.selectChannelValue,
          goodsIdOrName: this.goodsNumName,
          brandId: this.selectBrandType,
          classId: this.selectClassificationType,
          sizeName: this.sizeVal,
          gender: this.selectGender,
          priceRange: this.selectPriceRange,
          discountRange: this.selectDiscountRange,
          goodsYear: this.selectYear,
          goodsSeason: this.selectQuarter,
          sortType: this.selectSort,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.orderParams = params;
        this.$axios.post(this.Global.getRetailGoodsPageData, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res.data) {
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
                for (let i = 0; i < self.list.length; i++) {
                  self.$set(self.list[i], 'channel', []); // 渠道信息集合数组
                  self.$set(self.list[i], 'sizeStockTotal', 0); // 总库存合计
                  self.$set(self.list[i], 'sizeStockList', []); // 各尺码库存合计
                  self.list[i].channel = self.list[i].BaseStoreroomList;

                  for (let j = 0; j < self.list[i].BaseStoreroomList.length; j++) {
                    self.$set(self.list[i].channel[j], 'sizeMsgList', []);
                    self.$set(self.list[i].channel[j], 'stockTotal', 0);

                    // 遍历尺码
                    for (let k = 0; k < self.list[i].BaseSizeList.length; k++) {
                      // 添加渠道尺码
                      self.list[i].channel[j].sizeMsgList.push({
                        size: self.list[i].BaseSizeList[k].Size,
                        sizeId: self.list[i].BaseSizeList[k].SizeId,
                        skuId: null,
                        stock: 0,
                        orderNum: 0
                      });

                      // 遍历库存
                      for (let g = 0; g < self.list[i].StockList.length; g++) {
                        if ((self.list[i].channel[j].StoreroomId === self.list[i].StockList[g].StoreroomId) && (self.list[i].channel[j].sizeMsgList[k].size === self.list[i].StockList[g].Size)) {
                          self.list[i].channel[j].sizeMsgList[k].skuId = self.list[i].StockList[g].SkuId;
                          self.list[i].channel[j].sizeMsgList[k].stock = self.list[i].StockList[g].Stock;
                          // self.list[i].channel[j].sizeMsgList[k].CostDiscount = self.list[i].StockList[g].CostDiscount;
                          // self.list[i].channel[j].sizeMsgList[k].CostPrice = self.list[i].StockList[g].CostPrice;
                          // self.list[i].channel[j].sizeStockList[k] = self.Global.addition(self.list[i].channel[j].sizeStockList[k], self.list[i].channel[j].sizeMsgList[k].stock);
                        }
                      }

                      self.list[i].channel[j].stockTotal = self.list[i].channel[j].stockTotal + self.list[i].channel[j].sizeMsgList[k].stock;
                    }
                  }

                  /* 各个尺码对应的总库存 */
                  for (let k = 0; k < self.list[i].BaseSizeList.length; k++) {
                    self.list[i].sizeStockList.push({size: self.list[i].BaseSizeList[k].Size, stock: 0});
                    for (let g = 0; g < self.list[i].channel.length; g++) {
                      for (let h = 0; h < self.list[i].channel[g].sizeMsgList.length; h++) {
                        if (self.list[i].BaseSizeList[k].Size === self.list[i].channel[g].sizeMsgList[h].size) {
                          self.list[i].sizeStockList[k].stock = self.list[i].sizeStockList[k].stock + self.list[i].channel[g].sizeMsgList[h].stock;
                        }
                      }
                    }
                  }

                  for (let k = 0; k < self.list[i].sizeStockList.length; k++) {
                    self.list[i].sizeStockTotal = self.list[i].sizeStockTotal + self.list[i].sizeStockList[k].stock;
                  }
                }
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
          console.log(this.list);
        });
      },

     // 获取价格可选范围下拉框信息
      getPriceRangeSelData() {
        this.$axios.get(this.Global.getPriceRangeSelData).then((res) => {
          if (!res.data.errorMsg.length) {
            this.priceRangeList = res.data.resData;
            this.priceRangeList.splice(0, 0, {id: '', text: '价格范围'});
            this.selectPriceRange = '';
          } else {
            this.priceRangeList = [];
            this.selectPriceRange = res.data.errorMsg;
          }
        });
      },

      // 获取折扣可选范围下拉框信息
      getCostDiscountSelData() {
        this.$axios.get(this.Global.getCostDiscountSelData).then((res) => {
          if (!res.data.errorMsg.length) {
            this.discountRangeList = res.data.resData;
            this.discountRangeList.splice(0, 0, {id: '', text: '折扣范围'});
            this.selectDiscountRange = '';
          } else {
            this.discountRangeList = [];
            this.selectDiscountRange = res.data.errorMsg;
          }
        });
      },

      // 获取上市年份
      getMarketYearSelData() {
        this.$axios.get(this.Global.getMarketYearSelData).then((res) => {
          if (!res.data.errorMsg.length) {
            this.yearList = res.data.resData;
            this.yearList.splice(0, 0, {id: 0, text: '年份'});
            this.selectYear = 0;
          } else {
            this.yearList = [];
            this.selectYear = res.data.errorMsg;
          }
        });
      },

      // 获取渠道下拉框信息
      getAllStoreroomsList() {
        this.$axios.get(this.Global.getAllStoreroomsList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.channelList = res.data.resData;
            // this.channelList.splice(0, 0, {id: '', text: '所有渠道'});
            // this.selectChannelValue = '';
          } else {
            this.channelList = [];
            this.selectChannelValue = res.data.errorMsg;
          }
        });
      },

      // 加载品牌下拉数据
      getAllBrandsList() {
        this.$axios.get(this.Global.getAllBrandsList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.brandTypeList = res.data.resData;
            this.brandTypeList.splice(0, 0, {id: '', text: '所有品牌'});
            this.selectBrandType = '';
          } else {
            this.brandTypeList = [];
            this.selectBrandType = res.data.errorMsg;
          }
        });
      },

      // 加载分类下拉数据
      getAllClassList() {
        this.$axios.get(this.Global.getAllClassList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.codeClassificationList = res.data.resData;
            this.codeClassificationList.splice(0, 0, {id: '', text: '所有分类'});
            this.selectClassificationType = '';
          } else {
            this.codeClassificationList = [];
            this.selectClassificationType = res.data.errorMsg;
          }
        });
      },

      // 判断正整数
      judgedPositiveInteger(index, channelI, sizeI) {

      },

      // 获取当前登录用户的分销商的购物车信息
      getShoppingCartData() {
        this.$axios.get(this.Global.getShoppingCartData).then((res) => {
          if (!res.data.errorMsg.length) {
            console.log(res.data.resData);
            this.$store.commit('addCarGoods', res.data.resData);
          }
        });
      },

      // 添加货品到购物车
      addToShoppingCart(GoodsId, index, channelI, sizeI) {
        console.log(this.goodsList);
        // const carList = [];
        const carList = this.goodsList;
        let idExist = carList.findIndex(item => {
          return (item.GoodsId === GoodsId &&
            item.StoreroomId === this.list[index].channel[channelI].StoreroomId &&
            item.Size === this.list[index].channel[channelI].sizeMsgList[sizeI].size);
        });
        console.log(idExist);
        if (idExist === -1) {
          const params = [{
            goodsId: GoodsId,
            skuId: this.list[index].channel[channelI].sizeMsgList[sizeI].skuId,
            storeroomId: this.list[index].channel[channelI].StoreroomId,
            quantity: 1
          }];
          this.$axios.post(this.Global.addToShoppingCart, params).then((res) => {
            if (!res.data.errorMsg.length) {
              this.getShoppingCartData();
              this.isTip = true;
            }
          });
        } else {
          this.isTip = true;
        }
      },

      // 批量添加购物车
      batchAddCarData(goodsId, storeroomId, goodsMsg, channelI) {
        this.batchTxt = goodsId + '_' + storeroomId;
        this.batchBtn = goodsId + '_' + storeroomId;
        this.batchBtnSubmit = goodsId + '_' + storeroomId;
        this.batchMask = true;
        this.goodsMsg = goodsMsg;
        this.channelI = channelI;
      },

      // 批量下单
      batchAddCar() {
        this.batchMask = false;
        this.batchTxt = null;
        this.batchBtnSubmit = null;
        let params = [];
        for (let i = 0; i < this.goodsMsg.channel[this.channelI].sizeMsgList.length; i++) {
          let quantity = parseInt(this.goodsMsg.channel[this.channelI].sizeMsgList[i].orderNum);
          if (this.goodsMsg.channel[this.channelI].sizeMsgList[i].stock !== 0 && parseInt(this.goodsMsg.channel[this.channelI].sizeMsgList[i].orderNum) !== 0) {
            if (quantity > this.goodsMsg.channel[this.channelI].sizeMsgList[i].stock) {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = '购物车数量不能大于库存数量';
              return;
            } else {
              params.push({
                goodsId: this.goodsMsg.GoodsId,
                skuId: this.goodsMsg.channel[this.channelI].sizeMsgList[i].skuId,
                storeroomId: this.goodsMsg.channel[this.channelI].StoreroomId,
                quantity: parseInt(this.goodsMsg.channel[this.channelI].sizeMsgList[i].orderNum)
              });
            }
          }
        }
        if (params.length) {
          this.$axios.post(this.Global.addToShoppingCart, params).then((res) => {
            if (!res.data.errorMsg.length) {
              this.getShoppingCartData();
              this.isTip = true;
            }
          });
        }
      },

      // 添加购物车
      addToCar(GoodsId, index, channelI, sizeI) {
        const carList = this.goodsList;
        let idExist = carList.find(item => {
          return (item.GoodsId === GoodsId &&
            item.StoreroomId === this.list[index].channel[channelI].StoreroomId &&
            item.Size === this.list[index].channel[channelI].sizeMsgList[sizeI].size);
        });

        if (!idExist) {
          const data = {
            GoodsId: GoodsId,
            BrandName: this.list[index].BrandName,
            StoreroomName: this.list[index].channel[channelI].StoreroomName,
            Size: this.list[index].channel[channelI].sizeMsgList[sizeI].size,
            brand: '品牌',
            channel: '渠道',
            size: '尺码',
            postSeason: '发布季',
            inventory: '库存',
            num: 1,
            originalPrice: '原价',
            discount: '折扣',
            actualUnitPrice: '实际单价',
            weight: '重量',
            actualAmount: '实际金额',
            url: '地址',
            title: '货品名'
          };
          this.$store.commit('addCarGoods', data);
          this.isTip = true;
        }
      },

      // 导出库存
      exportInventory() {
        this.orderParams = {
          storeroomId: this.selectChannelValue,
          goodsIdOrName: this.goodsNumName,
          brandId: this.selectBrandType,
          classId: this.selectClassificationType,
          sizeName: this.sizeVal,
          gender: this.selectGender,
          priceRange: this.selectPriceRange,
          discountRange: this.selectDiscountRange,
          goodsYear: this.selectYear,
          goodsSeason: this.selectQuarter,
          sortType: this.selectSort,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.dialogTitle = '导出字段选择';
        this.isShow = true;
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        this.getRetailGoodsPageData();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getRetailGoodsPageData();
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      },

      // 接受提示框是否关闭数据
      closeTipDialog(e) {
       this.isTip = e;
      }
    },
    created() {
      this.getAllStoreroomsList();
      this.getAllBrandsList();
      this.getAllClassList();
      this.getPriceRangeSelData();
      this.getCostDiscountSelData();
      this.getMarketYearSelData();
      // this.getRetailGoodsPageData();
    },
    activated() { // 只有keep-alive激活才会被使用
      if (sessionStorage.getItem('isRefresh') === 'true') { // 从左边的菜单进去刷新页面
        sessionStorage.setItem('isRefresh', 'false');
        this.list = [];
        this.goodsNumName = null;
        this.isShow = false;
        this.currentPage = 1;
        this.pageSize = 10;
        this.getAllStoreroomsList();
        this.getAllBrandsList();
        this.getAllClassList();
        this.getPriceRangeSelData();
        this.getCostDiscountSelData();
        this.getMarketYearSelData();
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .retail_order {
    background-color: #ffffff;
    height: 100%;
    position: relative;

    .retail_order_top {
      padding-top: 10px;

      .first_line, .second_line {
        display: flex;
        margin-bottom: 10px;
        padding-left: 10px;

        & > div {
          display: inline-block;
          width: 14%;
          margin-right: 1%;
          /*margin-right: 1%;*/

          &.w_percent10 {
            width: 10%;
          }

          &.w_percent15 {
            width: 15%;
          }
        }
      }
    }

    .retail_order_msg {
      height: calc(100% - 118px);
      margin-left: 10px;
      margin-right: 5px;
      border: 1px solid #eee;
      padding: 10px 5px;
      overflow: auto;

      .retail_order_msg_content {
        /*font-size: 12px;*/
      }

      input[type='number'] {
        text-align: center;
        width: 40px;
        position: relative;
        z-index: 100;
      }

      .batch_hover {
        &:hover {
          color: red;
          cursor: pointer;
        }
      }

      .batch_import {
        &:hover a.pa{
          /*display: inline-block;*/
        }

        a.pa {
          /*display: none;*/
          background: #169BD5;
          color: #fff;
          font-size: 12px;
          padding: 2px 5px;
          /*top: 29%;*/
          /*left: 36px;*/
          /*left: 61px;*/
          right: -58px;
        }
      }

      .table {
        th, td {
          border: 1px solid #ddd;
        }

        th {
          background-color: rgba(246, 246, 246, 1);
        }

        tr:last-child td {
          background-color: rgba(246, 246, 246, 1);
        }
      }
    }

    .retail_order_mask {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 99;
      /*background-color: rgba(0,0,0,.3);*/
    }
  }
</style>

<style lang="scss">
  .warehouse_msg {
    background-color: blanchedalmond;
    ul {
      li {
        padding: 5px 0;
        border-bottom: 1px solid #fff;
      }
    }
    i {
      font-style: normal;
    }
  }

  .warehouse_notice {
    .notice_list {
      background-color: #ddd;
      margin: -12px -12px 0;
      padding: 12px;

      i {
        font-style: normal;
        float: right;
      }
    }

    ul {
      li {
        padding: 5px 0;
        border-bottom: 1px solid #eee;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/sales-management/retail-order.vue